import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getChecklistRequest: ['roleId', 'category'],
  getChecklistSuccess: ['response', 'category'],
  getChecklistFailure: null,

  getChecklistByCategoryRequest: ['category'],
  getChecklistByCategorySuccess: ['response', 'category'],
  getChecklistByCategoryFailure: null,

  createChecklistItemsMultipleRequest: ['payload'],
  createChecklistItemsMultipleSuccess: ['response'],
  createChecklistItemsMultipleFailure: null,

  createChecklistItemRequest: ['payload'],
  createChecklistItemSuccess: ['response'],
  createChecklistItemFailure: null,

  editChecklistItemRequest: ['checklistItemId', 'payload'],
  editChecklistItemSuccess: ['response'],
  editChecklistItemFailure: ['checklistItemId'],

  deleteChecklistItemRequest: ['checklistItemId', 'category'],
  deleteChecklistItemSuccess: ['checklistItemId', 'category'],
  deleteChecklistItemFailure: ['checklistItemId', 'category'],

  submitUserNTChecklistRequest: ['payload'],
  submitUserNTChecklistSuccess: ['response'],
  submitUserNTChecklistFailure: null,

  fetchUserChecklistRequest: ['id'],
  fetchUserChecklistSuccess: ['response'],
  fetchUserChecklistFailure: null,

  getUserNTChecklistRequest: ['userId'],
  getUserNTChecklistSuccess: ['userId', 'response'],
  getUserNTChecklistFailure: ['userId'],

  submitStartShiftChecklistRequest: ['payload'],
  submitStartShiftChecklistSuccess: ['response'],
  submitStartShiftChecklistFailure: null,

  submitEndShiftChecklistRequest: ['payload'],
  submitEndShiftChecklistSuccess: ['response'],
  submitEndShiftChecklistFailure: null,

  getUserShiftChecklistRequest: ['userId', 'shiftTimeId', 'category'],
  getUserShiftChecklistSuccess: ['response', 'category'],
  getUserShiftChecklistFailure: null,

  clearSuccessSubmitUserNTChecklistRequest: null,
  clearSuccessSubmitStartShiftChecklistRequest: null,
  clearSuccessSubmitEndShiftChecklistRequest: null,

  // Clear all caches
  clearChecklistRequest: null,
});

export const ChecklistTypes = Types;
export default Creators;
